export default "/_next/static/images/Process_Step_2-0c30eef3958c97634ff3370ead806032.jpg";